import { render, staticRenderFns } from "./tab-waiting.vue?vue&type=template&id=5f459485&"
import script from "./tab-waiting.vue?vue&type=script&lang=js&"
export * from "./tab-waiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports